module.exports = __webpack_public_path__ + "static/media/bg13.c9b95f45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg13.jpg
// module id = 5174
// module chunks = 0